import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Medal } from 'phosphor-react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAvatarIcon } from './AvatarSelector';

function RankingList() {
  const [ranking, setRanking] = useState([]);
  const currentUsername = localStorage.getItem('username');

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/ranking`);
        setRanking(response.data);
      } catch (error) {
        console.error('Błąd podczas pobierania rankingu:', error);
      }
    };

    fetchRanking();
    const interval = setInterval(fetchRanking, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-4 border border-gray-700">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-white">Ranking</h2>
      </div>
      <div className="space-y-3">
        {ranking.map((user, index) => (
          <div 
            key={user.username} 
            className={`flex items-center gap-3 p-2 rounded-lg transition-all duration-200
              ${user.username === currentUsername 
                ? 'bg-blue-900/50 border border-blue-700/50' 
                : 'hover:bg-gray-700/50'}`}
          >
            <div className="w-8 text-center font-bold text-gray-400">
              {index + 1}
            </div>
            <div className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full">
              {getAvatarIcon(user.avatar)}
            </div>
            <div className="flex-1">
              <div className="font-medium text-white">{user.displayName || user.username}</div>
              <div className="text-sm text-gray-400">{user.total_points} pkt</div>
            </div>
            {index < 3 && (
              <Medal 
                size={24} 
                weight="fill" 
                className={
                  index === 0 
                    ? 'text-yellow-500' 
                    : index === 1 
                    ? 'text-gray-400' 
                    : 'text-amber-600'
                } 
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default RankingList;
